import client from '../httpClient';

const postSendMailsBulk = (params, isShowMessage = true) => {
  return client.post('/send-mails/bulk', params, { isShowMessage, isShowLoading: false });
};

export default postSendMailsBulk;
